import { addDays, lastDayOfISOWeek, startOfDay, startOfISOWeek } from "date-fns"

export function twoWeeks(start: Date) {
    const firstDayOfWeek = startOfISOWeek(startOfDay(start))
    const lastDayOfFirstWeek = lastDayOfISOWeek(startOfDay(start))

    const firstWeek = [...(Array(7) as [])].map((_, i) => addDays(firstDayOfWeek, i))
    const secondWeek = [...(Array(7) as [])].map((_, i) => addDays(lastDayOfFirstWeek, i + 1))
    return [firstWeek, secondWeek]
}
